import { render, staticRenderFns } from "./Tests.vue?vue&type=template&id=55cc044b&scoped=true"
import script from "./Tests.vue?vue&type=script&lang=js"
export * from "./Tests.vue?vue&type=script&lang=js"
import style0 from "./Tests.vue?vue&type=style&index=0&id=55cc044b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cc044b",
  null
  
)

export default component.exports